<template>
    <default-field :errors="errors" :title="title" :wrap="wrap">
        <template v-slot:field="slotProps">
            <v-select
                class="bg-white"
                :class="[slotProps.hasErrors ? invalidClass : '', className]"
                v-bind="$attrs"
                v-on:input="setValue"
                :reduce="item => item[valueName]"
                :multiple="multiple"
                :options="options"
            />
        </template>
    </default-field>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DefaultField from "./DefaultField";

export default {
    components: {
        DefaultField
    },

    inheritAttrs: false,

    props: {
        className: {
            type: String,
            default: ""
        },
        invalidClass: {
            type: String,
            default: "is-invalid"
        },
        errors: {
            type: Array,
            default: () => []
        },
        valueName: {
            type: String,
            default: "value"
        },
        options: {
            type: Array
        },
        title: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        wrap: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        setValue(value) {
            this.$emit("input", value);
        }
    }
};
</script>